import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import KeywordSearchLink from 'components/Global/Tag/KeywordSearchLink.jsx';
import { submitAdvancedSearch, UPDATE_ADVANCED_SEARCH } from 'components/Pages/AdvancedSearch/actions.js';
import SearchBar from '@bit/knotchinc.web-react-components.search-bar';
import { numberWithCommas } from 'helpers/Utils.js';
import { PageBody } from '@bit/knotchinc.web-react-components.page';
import ResultsScrollCol from './ResultsScrollCol.jsx';
import { ContentPreviewContainer, PreviewContainer, PreviewCol,
  SearchTitle, StyledViewAllButton, ResultsContainer } from './styled.js';
import {
  TOGGLE_SEARCH_PREVIEW,
  SET_SEARCH_PREVIEW_KEYWORDS_FILTER,
  SET_SEARCH_PREVIEW_BRANDS_FILTER,
  SET_SEARCH_PREVIEW_PUBLISHERS_FILTER,
  SET_SEARCH_PREVIEW_PAID_CONTENT_FILTER,
  SET_SEARCH_PREVIEW_OWNED_CONTENT_FILTER,
  FETCH_ALL_SEARCHES,
  fetchKeywordsSearchPreview,
  fetchBrandsSearchPreview,
  fetchPublishersSearchPreview,
  fetchOwnedContentSearchPreview,
  CLEAR_ALL_SEARCHES,
  fetchPaidContentSearchPreview,
} from './actions.js';

export const PreviewResults = props => {
  const {
    paidContentList,
    ownedContentList,
    keywordsList,
    brandsList,
    publishersList,
    handleAdvancedSearch,
    fetchKeywords,
    fetchBrands,
    fetchPublishers,
    fetchPaidContent,
    fetchOwnedContent,
    searchQuery,
   } = props;
  const paidContentTotal = paidContentList.pagination && paidContentList.pagination.total;
  const ownedContentTotal = ownedContentList.pagination && ownedContentList.pagination.total;

  return (
    <PreviewContainer splitView>
      <PerfectScrollbar>
        <PageBody maxWidth="1600px">
          {/* Brands */}
          <ResultsContainer shown={searchQuery.length > 2}>
            <PreviewCol>
              <ResultsScrollCol
                title="BRAND RESULTS"
                fetch={fetchBrands}
                listStore={brandsList}
                actionType={SET_SEARCH_PREVIEW_BRANDS_FILTER}
                Component={EntityItem}
              />
            </PreviewCol>
            {/* Publishers */}
            <PreviewCol>
              <ResultsScrollCol
                title="PUBLISHERS RESULTS"
                fetch={fetchPublishers}
                listStore={publishersList}
                actionType={SET_SEARCH_PREVIEW_PUBLISHERS_FILTER}
                Component={EntityItem}
              />
            </PreviewCol>
            {/* Keywords */}
            <PreviewCol>
              <ResultsScrollCol
                title="KEYWORDS RESULTS"
                fetch={fetchKeywords}
                listStore={keywordsList}
                actionType={SET_SEARCH_PREVIEW_KEYWORDS_FILTER}
                Component={KeywordSearchLink}
              />
            </PreviewCol>
            {/* Paid Content */}
            <ContentPreviewContainer splitView>
              <SearchTitle>
              PAID CONTENT RESULTS
              {paidContentTotal > 0 &&
              <React.Fragment>
                <span>{numberWithCommas(paidContentTotal)}</span>
                <StyledViewAllButton onClick={() => handleAdvancedSearch('paid')}>View All</StyledViewAllButton>
              </React.Fragment>
              }
              </SearchTitle>
              <ListSync
                fetch={clear => fetchPaidContent(clear)}
                listStore={paidContentList}
                actionType={SET_SEARCH_PREVIEW_PAID_CONTENT_FILTER}
              >
                <ContentCard />
              </ListSync>
            </ContentPreviewContainer>
            <ContentPreviewContainer splitView>
              <SearchTitle>
              OWNED CONTENT RESULTS
              {ownedContentTotal > 0 &&
              <React.Fragment>
                <span>{numberWithCommas(ownedContentTotal)}</span>
                <StyledViewAllButton onClick={() => handleAdvancedSearch('owned')}>View All</StyledViewAllButton>
              </React.Fragment>
              }
              </SearchTitle>
              <ListSync
                fetch={clear => fetchOwnedContent(clear)}
                listStore={ownedContentList}
                actionType={SET_SEARCH_PREVIEW_OWNED_CONTENT_FILTER}
              >
                <ContentCard />
              </ListSync>
            </ContentPreviewContainer>
          </ResultsContainer>
        </PageBody>
      </PerfectScrollbar>
    </PreviewContainer>
  );
};

export class BlueprintSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
    };
    this.search = val => {
      this.setState({ searchQuery: val });
      if (val.length >= 3) {
        this.props.fetchPreview(val);
      } else {
        this.props.clearSearch(val);
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open) {
      document.body.style.overflow = 'hidden';
    }
  }

  handleOpen() {
    const { openPreview } = this.props;
    document.body.style.overflow = 'hidden';
    openPreview();
  }

  handleClose() {
    const { closePreview } = this.props;
    document.body.style.overflow = 'auto';
    closePreview();
  }

  handleAdvancedSearch(type) {
    const { updateAdvancedSearch, searchQuery, submit, history } = this.props;
    updateAdvancedSearch('searchBy', 'title');
    updateAdvancedSearch('searchQuery', searchQuery);
    updateAdvancedSearch('content_type', type);
    submit();
    history.push('/blueprint/search');
  }

  render() {
    const { pathname, open, searchQuery } = this.props;

    return (
      <SearchBar
        pathname={pathname}
        placeholder="Search for anything"
        onChange={this.search}
        externalOpen={open}
        onExit={() => this.handleClose()}
        onOpen={() => this.handleOpen()}
        externalSearchQuery={searchQuery}
      >
        {open &&
          <PreviewResults
            searchQuery={this.state.searchQuery}
            handleAdvancedSearch={type => this.handleAdvancedSearch(type)}
            {...this.props}
          />
        }
      </SearchBar>
    );
  }
}

SearchBar.defaultProps = {
  showList: false,
};

const mapStateToProps = ({
  SearchPreview: {
    paidContentList,
    ownedContentList,
    keywordsList,
    brandsList,
    publishersList,
    open,
    searchQuery,
  },
}) => ({
  paidContentList,
  ownedContentList,
  keywordsList,
  brandsList,
  publishersList,
  open,
  searchQuery,
});

const mapDispatchToProps = dispatch => ({
  fetchKeywords: clear => dispatch(fetchKeywordsSearchPreview(clear)),
  fetchBrands: clear => dispatch(fetchBrandsSearchPreview(clear)),
  fetchPublishers: clear => dispatch(fetchPublishersSearchPreview(clear)),
  fetchPaidContent: clear => dispatch(fetchPaidContentSearchPreview(clear)),
  fetchOwnedContent: clear => dispatch(fetchOwnedContentSearchPreview(clear)),
  fetchPreview: searchQuery => dispatch({ type: FETCH_ALL_SEARCHES, searchQuery }),
  clearSearch: (searchQuery) => dispatch({ type: CLEAR_ALL_SEARCHES, searchQuery }),
  openPreview: () => dispatch({ type: TOGGLE_SEARCH_PREVIEW, open: true }),
  closePreview: () => {
    dispatch({ type: TOGGLE_SEARCH_PREVIEW, open: false });
  },
  updateAdvancedSearch: (field, value) => dispatch({ type: UPDATE_ADVANCED_SEARCH, data: { field, value } }),
  submit: () => dispatch(submitAdvancedSearch()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BlueprintSearch));
